"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapPackageEquipment = void 0;
const get_component_from_item_by_id_1 = require("./components/get-component-from-item-by-id");
const get_component_values_1 = require("./components/get-component-values");
// @ts-ignore
const lodash_1 = require("lodash");
const mapPackageEquipment = (salesPackage) => {
    const name = (0, get_component_values_1.getSingleLineComponentValue)((0, get_component_from_item_by_id_1.getComponentFromItemById)(salesPackage, 'salesPackage'));
    const packageEquipmentChunks = (0, get_component_values_1.getContentChunks)((0, get_component_from_item_by_id_1.getComponentFromItemById)(salesPackage, 'packageEquipment'));
    const equipment = packageEquipmentChunks === null || packageEquipmentChunks === void 0 ? void 0 : packageEquipmentChunks.flatMap((chunk) => { var _a; return (_a = chunk[0].content) === null || _a === void 0 ? void 0 : _a.text; });
    return {
        id: salesPackage.id,
        name: name !== null && name !== void 0 ? name : null,
        additionalPrice: null,
        equipment: (0, lodash_1.compact)(equipment !== null && equipment !== void 0 ? equipment : []),
    };
};
exports.mapPackageEquipment = mapPackageEquipment;
//# sourceMappingURL=map-package-equipment.js.map